module.exports = __webpack_public_path__ + "img/ic_not_task_order.da01ec62.svg";